import { IconProps } from '@/types/icon';

export function IconeBusca({ size, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="busca"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M9.50332 8.50326H8.97665L8.78998 8.32326C9.44332 7.56326 9.83665 6.57659 9.83665 5.50326C9.83665 3.10992 7.89665 1.16992 5.50332 1.16992C3.10998 1.16992 1.16998 3.10992 1.16998 5.50326C1.16998 7.89659 3.10998 9.83659 5.50332 9.83659C6.57665 9.83659 7.56332 9.44326 8.32332 8.78992L8.50332 8.97659V9.50326L11.8366 12.8299L12.83 11.8366L9.50332 8.50326ZM5.50332 8.50326C3.84332 8.50326 2.50332 7.16326 2.50332 5.50326C2.50332 3.84326 3.84332 2.50326 5.50332 2.50326C7.16332 2.50326 8.50332 3.84326 8.50332 5.50326C8.50332 7.16326 7.16332 8.50326 5.50332 8.50326Z"
        fill="currentColor"
      />
    </svg>
  );
}
